export const checkIfInternalIp =
  () =>
  (dispatch, getState, { api }) =>
    api.checkIfInternalIp().then(
      (data) => ({ wasSuccessful: true, isInternalIp: data.isInternalIp }),
      () => ({ wasSuccessful: false }),
    );
